<template>
  <div class="site-setup">
    <div class="setup-steps">
      <SetupSteps :activeIndex="activeIndex" />
    </div>

    <div class="setup-content">
      <transition name="fade" mode="out-in">
        <router-view :key="_uid"/>
      </transition>
    </div>
  </div>
</template>

<script>
import SetupSteps from '@/views/SiteSetup/SetupSteps'

export default {
  name: 'siteSetup',

  components: {
    SetupSteps
  },

  computed: {
    activeIndex() {
      let routeName = this.$route.name
      let getStartedRoute = 'getStarted'
      let homeContentRoutes = ['homeContent', 'showHomeContent', 'editHomeContent']
      let otherContentRoutes = [
        'otherContent',
        'servicesContent',
        'reviewsContent',
        'socialMediaContent',
        'logoContent',
        'otherContentFinal']
      let sitePreviewRoute = 'sitePreview'

      if (routeName === getStartedRoute) return 1
      if (homeContentRoutes.includes(routeName)) return 2
      if (otherContentRoutes.includes(routeName)) return 3
      if (routeName === sitePreviewRoute) return 4
      return 0
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.slide-leave-active,
.slide-enter-active
  transition: .75s ease-in-out

.slide-enter
  transform: translateY(100%)

.slide-leave-to
  transform: translateY(-100%)

.site-setup
  height: calc(100vh - #{$header-height})

  @include media($media-gt-medium)
    display: flex

  .banner
    h2
      .typed
        color: rgba(255, 255, 255, 0.5)

  .setup-steps
    display: none

    @include media($media-gt-medium)
      display: flex
      flex-basis: 25%
      box-shadow: 0 30px 50px rgba(0, 0, 0, 0.15)
      z-index: 1

  .setup-content
    overflow: auto
    position: relative

    @include media($media-gt-medium)
      flex-basis: 75%

.content-intro
  max-width: 600px
  text-align: center
  margin: $gap-large auto 100px

  .btn
    display: block
    margin: $gap-large auto
    animation: pulse 1s infinite ease-in-out
</style>
